import { Matrix } from "../../maths/Matrix";
import { Pool } from "../../utils/Pool";
export class RotateCmd {
    static create(angle, pivotX, pivotY) {
        var cmd = Pool.getItemByClass("RotateCmd", RotateCmd);
        cmd.angle = angle;
        cmd.pivotX = pivotX;
        cmd.pivotY = pivotY;
        return cmd;
    }
    recover() {
        Pool.recover("RotateCmd", this);
    }
    run(context, gx, gy) {
        context._rotate(this.angle, this.pivotX + gx, this.pivotY + gy);
    }
    getBounds(assembler) {
        tempMatrix.identity();
        tempMatrix.translate(-this.pivotX, -this.pivotY);
        tempMatrix.rotate(this.angle);
        tempMatrix.translate(this.pivotX, this.pivotY);
        assembler.concatMatrix(tempMatrix);
    }
    get cmdID() {
        return RotateCmd.ID;
    }
}
RotateCmd.ID = "Rotate";
const tempMatrix = new Matrix();
